import parseUserAgent from '../parseUserAgent';

import secondFactorLabelOk from './secondFactorLabelOk';

// A passkey lives in the browser or system that created it, so their names tell the user which one it is
const webauthnDefaultLabel = (kind, translate) => {
  if (kind === 'passkey') {
    const { browserName, osName } = parseUserAgent(globalThis.navigator?.userAgent);
    const label = [browserName, osName].filter(Boolean).join(' - ');
    if (secondFactorLabelOk(label)) return label;
    return translate('passkey');
  }

  return translate('securityKey');
};

export default webauthnDefaultLabel;
